export enum MessageType {
    // Requests
    Ping = "p",
    Connect = "C",
    Subscribe = "S",
    Unsubscribe = "U",
    Publish = "P",
    // Responses
    Pong = "g",
    PubMsg = "M",
}
